import React from "react";
import { FormattedMessage } from "react-intl";

import SecureScoreProfileConstants from "./secure-score-profile-constants";

const secureScoreProfilePostureConfigs = ({
  AUGMENTT_POSTURE_STATES,
  COMPLIANCE_TYPES,
}) => {
  const secureScoreProfileConstants = new SecureScoreProfileConstants({
    COMPLIANCE_TYPES,
  });

  const { SECURE_SCORE_PROFILE_TYPES } = secureScoreProfileConstants;

  const keys = Object.keys(SECURE_SCORE_PROFILE_TYPES);
  const result = {};

  const secureScoreProfiles =
    secureScoreProfileConstants.getSecureScoreProfiles();

  keys.forEach((key) => {
    const type = SECURE_SCORE_PROFILE_TYPES[key];
    result[type] = {
      rationale: `SECURE.RATIONALE.${key}`,
      statusDetailsFormatter: (row) =>
        row.status === AUGMENTT_POSTURE_STATES.COMPLIANT ? (
          <FormattedMessage id={`SECURE.STATUS_DESCRIPTION.POSITIVE.${key}`} />
        ) : (
          <FormattedMessage id={`SECURE.STATUS_DESCRIPTION.NEGATIVE.${key}`} />
        ),
      compliance:
        secureScoreProfiles[type]?.compliance || COMPLIANCE_TYPES.NONE,
    };
  });

  return Object.freeze(result);
};

export { secureScoreProfilePostureConfigs };
